/**
 * Pure spectator-target selection. Shared by the realtime server (to validate
 * a requested target and pick defaults) and tests. Team filtering is built in
 * but only restricts when a team id is supplied — single-player survival passes
 * `undefined` and may watch any survivor; team modes (TEAM-1) pass the team id.
 */
/**
 * Selectable spectate targets for a spectator, highest run-score first.
 * Excludes the spectator and the dead; if `spectatorTeamId` is provided, only
 * same-team survivors qualify.
 */
export function selectableSpectateTargets(candidates, spectatorId, spectatorTeamId) {
    return candidates
        .filter((candidate) => candidate.id !== spectatorId && candidate.isAlive)
        .filter((candidate) => spectatorTeamId === undefined ||
        spectatorTeamId === null ||
        candidate.teamId === spectatorTeamId)
        .sort((left, right) => right.score - left.score);
}
export function isSpectateTargetAllowed(candidates, spectatorId, targetId, spectatorTeamId) {
    return selectableSpectateTargets(candidates, spectatorId, spectatorTeamId).some((candidate) => candidate.id === targetId);
}
/**
 * Default spectate target when no explicit one applies (e.g. the killer is
 * gone): the highest-ranked eligible survivor, or null if none remain.
 */
export function defaultSpectateTarget(candidates, spectatorId, spectatorTeamId) {
    return (selectableSpectateTargets(candidates, spectatorId, spectatorTeamId)[0]
        ?.id ?? null);
}
